/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-04-07 14:43:26
 * @LastEditTime: 2022-04-18 16:16:33
 * @FilePath: \insurforce-backstage-platform-side\src\views\claim\customerRecordManage\utils.js
 */
const columns = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '保单号'
  },
  dataIndex: 'policyNo',
  key: 'policyNo',
  align: 'center'
}, {
  slots: {
    title: '产品名称'
  },
  dataIndex: 'insuranceName',
  key: 'insuranceName',
  align: 'center'
}, {
  slots: {
    title: '承保机构'
  },
  dataIndex: 'agencyName',
  key: 'agencyName',
  align: 'center'
}, {
  slots: {
    title: '申请人'
  },
  dataIndex: 'userName',
  key: 'userName',
  align: 'center'
}, {
  slots: {
    title: '申请时间'
  },
  dataIndex: 'createAt',
  key: 'createAt',
  align: 'center'
}, {
  slots: {
    title: '审核状态'
  },
  dataIndex: 'status',
  key: 'status',
  align: 'center',
  customRender: text => {
    if (text === 0) {
      return '审核中';
    } else if (text === 1) {
      return '审核通过';
    }
    return '审核未通过';
  }
}, {
  slots: {
    title: '结案状态'
  },
  dataIndex: 'isClose',
  key: 'isClose',
  align: 'center',
  customRender: text => {
    return text === 0 ? '未结案' : '已结案';
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 250,
  scopedSlots: {
    customRender: 'operation'
  }
}];
const columns2 = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '保单号'
  },
  dataIndex: 'policyNo',
  key: 'policyNo',
  align: 'center'
}, {
  slots: {
    title: '产品名称'
  },
  dataIndex: 'insuranceName',
  key: 'insuranceName',
  align: 'center'
}, {
  slots: {
    title: '保单归属'
  },
  dataIndex: 'customerName',
  key: 'customerName',
  align: 'center'
}, {
  slots: {
    title: '出单组织'
  },
  dataIndex: 'structureName',
  key: 'structureName',
  align: 'center'
}, {
  slots: {
    title: '申请人'
  },
  dataIndex: 'userName',
  key: 'userName',
  align: 'center'
}, {
  slots: {
    title: '申请时间'
  },
  dataIndex: 'createAt',
  key: 'createAt',
  align: 'center'
}, {
  slots: {
    title: '审核状态'
  },
  dataIndex: 'status',
  key: 'status',
  align: 'center',
  customRender: text => {
    if (text === 0) {
      return '审核中';
    } else if (text === 1) {
      return '审核通过';
    }
    return '审核未通过';
  }
}, {
  slots: {
    title: '结案状态'
  },
  dataIndex: 'isClose',
  key: 'isClose',
  align: 'center',
  customRender: text => {
    return text === 0 ? '未结案' : '已结案';
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 250,
  scopedSlots: {
    customRender: 'operation'
  }
}];
const pagination = {
  showSizeChanger: true,
  showQuickJumper: true,
  total: 0,
  pageSize: 10,
  // 每页条数
  current: 1,
  showTotal: total => {
    return `共 ${total} 条`;
  },
  onShowSizeChange: (current, size) => {
    pagination.pageSize = size;
  }
};
const resultSelectList = [{
  key: 1,
  name: '理赔成功'
}, {
  key: 2,
  name: '理赔失败'
}];
const statusSelectList = [{
  key: 0,
  name: '未结案'
}, {
  key: 1,
  name: '已结案'
}];
const auditSelectList = [{
  key: 0,
  name: '审核中'
}, {
  key: 1,
  name: '审核通过'
}, {
  key: 2,
  name: '审核未通过'
}];
//客户自己能看到的
const policyListTag0 = [{
  name: '保单号',
  key: 'policyNo'
}, {
  name: '产品名称',
  key: 'insuranceName'
}, {
  name: '产品代码',
  key: 'insuranceCode'
}, {
  name: '承保单位',
  key: 'unitName'
}, {
  name: '机构全称',
  key: 'agencyName'
}, {
  name: '中介机构',
  key: 'intermediaryName'
}, {
  name: '生效日期',
  key: 'startAt'
}, {
  name: '终止日期',
  key: 'endAt'
}, {
  name: '保单状态',
  key: 'policyStatus'
}, {
  name: '等待期',
  key: 'waitTime'
}, {
  name: '申请人',
  key: 'applyUserName'
}, {
  name: '申请时间',
  key: 'createAt'
}];
//保司可以看到的
const policyListTag1 = [{
  name: '保单号',
  key: 'policyNo'
}, {
  name: '产品名称',
  key: 'insuranceName'
}, {
  name: '产品代码',
  key: 'insuranceCode'
}, {
  name: '中介机构',
  key: 'intermediaryName'
}, {
  name: '保单归属',
  key: 'customerName'
}, {
  name: '出单组织',
  key: 'issueUserName'
}, {
  name: '生效日期',
  key: 'startAt'
}, {
  name: '终止日期',
  key: 'endAt'
}, {
  name: '保单状态',
  key: 'policyStatus'
}, {
  name: '等待期',
  key: 'waitTime'
}, {
  name: '申请人',
  key: 'applyUserName'
}, {
  name: '申请时间',
  key: 'createAt'
}];
//中介可以看到的
const policyListTag2 = [{
  name: '保单号',
  key: 'policyNo'
}, {
  name: '产品名称',
  key: 'insuranceName'
}, {
  name: '产品代码',
  key: 'insuranceCode'
}, {
  name: '承保单位',
  key: 'unitName'
}, {
  name: '机构全称',
  key: 'agencyName'
}, {
  name: '保单归属',
  key: 'customerName'
}, {
  name: '出单组织',
  key: 'issueUserName'
}, {
  name: '生效日期',
  key: 'startAt'
}, {
  name: '终止日期',
  key: 'endAt'
}, {
  name: '保单状态',
  key: 'policyStatus'
}, {
  name: '等待期',
  key: 'waitTime'
}, {
  name: '申请人',
  key: 'applyUserName'
}, {
  name: '申请时间',
  key: 'createAt'
}];
//保司可以看到的
const policyListTag11 = [{
  name: '保单号',
  key: 'policyNo'
}, {
  name: '产品名称',
  key: 'insuranceRealName'
}, {
  name: '产品代码',
  key: 'insuranceCode'
}, {
  name: '中介机构',
  key: 'intermediaryName'
}, {
  name: '保单归属',
  key: 'customerName'
}, {
  name: '出单组织',
  key: 'issueUserName'
}, {
  name: '生效日期',
  key: 'startAt'
}, {
  name: '终止日期',
  key: 'endAt'
}, {
  name: '保单状态',
  key: 'policyStatus'
}, {
  name: '等待期',
  key: 'waitTime'
}, {
  name: '申请人',
  key: 'applyUserName'
}, {
  name: '申请时间',
  key: 'createAt'
}];
//中介可以看到的
const policyListTag21 = [{
  name: '保单号',
  key: 'policyNo'
}, {
  name: '产品名称',
  key: 'insuranceRealName'
}, {
  name: '产品代码',
  key: 'insuranceCode'
}, {
  name: '承保单位',
  key: 'unitName'
}, {
  name: '机构全称',
  key: 'agencyName'
}, {
  name: '保单归属',
  key: 'customerName'
}, {
  name: '出单组织',
  key: 'issueUserName'
}, {
  name: '生效日期',
  key: 'startAt'
}, {
  name: '终止日期',
  key: 'endAt'
}, {
  name: '保单状态',
  key: 'policyStatus'
}, {
  name: '等待期',
  key: 'waitTime'
}, {
  name: '申请人',
  key: 'applyUserName'
}, {
  name: '申请时间',
  key: 'createAt'
}];
const documentListColumns = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '资料名称'
  },
  dataIndex: 'documentName',
  key: 'documentName',
  align: 'center'
}, {
  slots: {
    title: '是否需要邮寄'
  },
  dataIndex: 'mail',
  key: 'mail',
  align: 'center',
  scopedSlots: {
    customRender: 'mail'
  }
}, {
  slots: {
    title: '备注'
  },
  dataIndex: 'remark',
  key: 'remark',
  align: 'center',
  scopedSlots: {
    customRender: 'remark'
  }
}];
const closeCasedocumentListColumns = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '资料名称'
  },
  dataIndex: 'documentName',
  key: 'documentName',
  align: 'center'
}, {
  slots: {
    title: '是否需要邮寄'
  },
  dataIndex: 'mail',
  key: 'mail',
  align: 'center',
  scopedSlots: {
    customRender: 'mail'
  }
}];
const documentColumns = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '资料名称'
  },
  dataIndex: 'documentName',
  key: 'documentName',
  align: 'center'
}, {
  slots: {
    title: '备注'
  },
  dataIndex: 'remark',
  key: 'remark',
  align: 'center',
  scopedSlots: {
    customRender: 'remark'
  }
}];
const consigneeListColumns = [{
  slots: {
    title: '收件人'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center',
  width: 150
}, {
  slots: {
    title: '联系方式'
  },
  dataIndex: 'mobile',
  key: 'mobile',
  align: 'center',
  width: 150
}, {
  slots: {
    title: '详细地址'
  },
  dataIndex: 'address',
  key: 'address',
  align: 'center',
  scopedSlots: {
    customRender: 'address'
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 170,
  scopedSlots: {
    customRender: 'operation'
  }
}];
// const consigneeColumns = [
//   {
//     title: '收件人',
//     dataIndex: 'name',
//     key: 'name',
//     align: 'center',
//     width: 150
//   },
//   {
//     title: '联系方式',
//     dataIndex: 'mobile',
//     key: 'mobile',
//     align: 'center',
//     width: 150
//   },
//   {
//     title: '详细地址',
//     dataIndex: 'address',
//     key: 'address',
//     align: 'center',
//     scopedSlots: {customRender: 'address'}
//   }
// ];
//快递列表
const logisticsSelectList = ['顺丰速运', '京东快递', 'EMS', '圆通快递', '邮政包裹', '中通快递', '申通快递', '韵达快递', '德邦物流', '百世汇通', '极速速递', '优速快递', '宅急送', '天天快递', '全峰快递'];
//结案校验信息
const closeCaseRule = {
  result: [{
    required: true,
    trigger: 'change',
    message: '请选择理赔结果'
  }],
  remark: [{
    required: true,
    trigger: 'blur',
    message: '请输入原因'
  }]
};
const closeCaseRule2 = {
  result: [{
    required: true,
    trigger: 'change',
    message: '请选择理赔结果'
  }],
  amount: [{
    required: true,
    trigger: 'blur',
    message: '请输入赔付金额'
  }],
  payoutAt: [{
    required: true,
    trigger: 'change',
    message: '请选择赔付时间'
  }],
  isBack: [{
    required: true,
    trigger: 'change',
    message: '请选择是否需要物理件回寄'
  }],
  logisticsCompany: [{
    required: true,
    trigger: 'change',
    message: '请选择物流公司'
  }],
  shipmentNum: [{
    required: true,
    trigger: 'blur',
    message: '请输入运单号'
  }],
  documentList: [{
    required: true,
    message: '至少选择一项资料',
    type: 'array'
  }]
};
const examineNoRule = {
  status: [{
    required: true,
    trigger: 'change',
    message: '请选择审核结果'
  }],
  remark: [{
    required: true,
    trigger: 'blur',
    message: '请输入备注'
  }]
};
const examineRule = {
  status: [{
    required: true,
    trigger: 'change',
    message: '请选择审核结果'
  }],
  isMailing: [{
    required: true,
    trigger: 'change',
    message: '请选择是否需要物理件邮寄'
  }]
};
const examineNoRemarkRule = {
  status: [{
    required: true,
    trigger: 'change',
    message: '请选择审核结果'
  }],
  content: [{
    required: true,
    trigger: 'blur',
    message: '请输入未通过原因'
  }]
};
export { columns, columns2, pagination, resultSelectList, statusSelectList, auditSelectList, policyListTag0, policyListTag1, policyListTag2, documentListColumns, consigneeListColumns, logisticsSelectList, documentColumns, closeCasedocumentListColumns, closeCaseRule, closeCaseRule2, examineNoRule, examineRule, examineNoRemarkRule, policyListTag11, policyListTag21 };

// consigneeColumns